import { Resource, Procedure } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'procedure', title: 'Procedure' },
  { code: 'date', title: 'Date' },
  { code: 'status', title: 'Status' },
  { code: 'note', title: 'Note' },
  { code: 'indication', title: 'Indication' },
  { code: 'doctor', title: 'Doctor' },
]

const renderColumn = (resource: Procedure, itemCode: string) => {
  switch (itemCode) {
    case 'procedure': {
      const cpt =
        resource.code?.coding?.find((c) => c.system?.includes('cpt'))?.code ||
        resource.code?.coding?.[0]?.code ||
        '-'
      const label = resource.code?.coding?.[0]?.display || resource.code?.text || '-'
      return (
        <div>
          <div>{label}</div>
          <div className="text-xs text-gray-500">CPT Code: {cpt}</div>
        </div>
      )
    }

    case 'date':
      return resource.performedDateTime
        ? formatDateTime(resource.performedDateTime, '-', true)
        : '-'

    case 'status':
      return resource.status || '-'

    case 'note':
      return resource.note?.map((item) => item.text).join('\n') || '-'

    case 'indication':
      return resource.reasonCode?.map((item) => item.text).join('\n') || '-'

    case 'doctor': {
      let doctor = resource.performer
        ?.map((p) => (typeof p.actor?.display === 'string' && p.actor.display) || '')
        .filter(Boolean)
        .join(', ')

      if (!doctor) {
        doctor =
          resource.extension?.find((e) => e.url.includes('record-recorder'))?.valueReference
            ?.display || '-'
      }
      return doctor || '-'
    }

    default:
      return itemCode
  }
}

export function Procedures({ resource }: Props) {
  const procedure = resource as Procedure

  if (!procedure) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {availFields.map((item) => (
            <tr>
              <td className="pr-4 text-right align-top whitespace-nowrap">
                <strong>{item.title}:</strong>
              </td>
              <td className="flex gap-2 align-top whitespace-pre-wrap">
                <div>{renderColumn(procedure, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
